import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

/**
 * Initialize i18next once. Safe to call multiple times — subsequent calls are no-ops.
 * Namespaces and translations are added lazily via useLoadLanguage / addResourceBundle.
 */
export function initI18n(options?: { debug?: boolean }) {
  if (i18n.isInitialized) return

  return i18n.use(initReactI18next).init({
    lng: 'en',
    fallbackLng: 'en',
    ns: [],
    interpolation: { escapeValue: false },
    debug: options?.debug,
  })
}
